const props = {
  MuiCardHeader: {
    titleTypographyProps: {
      variant: 'body2',
    },
  },
} as const;

export default props;
